import React from "react";
import { Footer, FooterLink, FooterNav, FooterList } from "@deere/fuel-react";
import {
  YouTube,
  Facebook,
  X,
  LinkedIn,
  Instagram,
  Email,
} from "@mui/icons-material";
import CountrySelector from "./CountrySelector";
import { Box, useMediaQuery, useTheme } from "@mui/material";

export default function FooterJOHN() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Footer copyrightDivider>
      <FooterNav
        aria-label="footer navigation"
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-around",
        }}
      >
        <Box sx={{ width: isMobile ? "100%" : "auto", padding: 2 }}>
          <FooterList column title="Products & Support">
            <FooterLink
              href="https://www.deere.com/en/equipment/"
              aria-label="Products & Support - Equipment"
              text="Equipment"
            />
            <FooterLink
              href="https://dealerlocator.deere.com/servlet/country=US"
              aria-label="Products & Support - Find a Dealer"
              text="Find a Dealer"
            />
            <FooterLink
              href="https://e-marketing.deere.com/ViewAllProducts.do"
              aria-label="Products & Support - Buy Online"
              text="Buy Online"
            />
            <FooterLink
              href="https://configure.deere.com/cbyo/#/en_us/products"
              aria-label="Products & Support - Build Your Own"
              text="Build Your Own"
            />
          </FooterList>
        </Box>
        <Box sx={{ width: isMobile ? "100%" : "auto", padding: 2 }}>
          <FooterList column title="Company Information">
            <FooterLink
              href="https://www.deere.com/en/our-company/about-john-deere/"
              aria-label="Company Information - About Us"
              text="About Us"
            />
            <FooterLink
              href="https://www.deere.com/en/our-company/technology-and-innovation/"
              aria-label="Company Information - Technology & Innovation"
              text="Technology & Innovation"
            />
            <FooterLink
              href="https://www.deere.com/en/our-company/sustainability/"
              aria-label="Company Information - Sustainability"
              text="Sustainability"
            />
            <FooterLink
              href="https://www.deere.com/en/our-company/john-deere-careers/"
              aria-label="Company Information - Careers"
              text="Careers"
            />
            <FooterLink
              href="https://investor.deere.com/governance/"
              aria-label="Company Information - Governance"
              text="Governance"
            />
            <FooterLink
              href="https://investor.deere.com/home/"
              aria-label="Company Information - Investor Relations"
              text="Investor Relations"
            />
            <FooterLink
              href="https://www.deere.com/en/our-company/news-and-announcements/"
              aria-label="Company Information - News and Announcements"
              text="News and Announcements"
            />
            <FooterLink
              href="https://www.deere.com/en/our-company/contact-us/"
              aria-label="Company Information - Contact Us"
              text="Contact Us"
            />
          </FooterList>
        </Box>
        <Box sx={{ width: isMobile ? "100%" : "auto", padding: 2 }}>
          <FooterList column title="Publications">
            <FooterLink
              href="https://johndeerejournal.com/"
              aria-label="Publications - John Deere Journal"
              text="John Deere Journal"
            />
            <FooterLink
              href="http://johndeerefurrow.com/"
              aria-label="Publications - The Furrow"
              text="The Furrow"
            />
            <FooterLink
              href="https://www.deere.com/en/publications/the-dirt/"
              aria-label="Publications - The Dirt"
              text="The Dirt"
            />
            <FooterLink
              href="https://www.deere.com/en/publications/the-landing/"
              aria-label="Publications - The Landing"
              text="The Landing"
            />
            <FooterLink
              href="https://www.deere.com/en/publications/industrial-powersource/"
              aria-label="Publications - Industrial PowerSource"
              text="Industrial PowerSource"
            />
            <FooterLink
              href="https://www.deere.com/en/publications/marine-powersource/"
              aria-label="Publications - Marine PowerSource"
              text="Marine PowerSource"
            />
          </FooterList>
        </Box>
        <Box sx={{ width: isMobile ? "100%" : "auto", padding: 2 }}>
          <FooterList column title="Connect with John Deere">
            <FooterLink
              href="https://www.deere.com/en/connect-with-john-deere/visit-john-deere/"
              aria-label="Connect with John Deere - Visit Us"
              text="Visit Us"
            />
            <FooterLink
              href="https://www.deere.com/en/connect-with-john-deere/visit-john-deere/factory-tours/"
              aria-label="Connect with John Deere - Factory Tours"
              text="Factory Tours"
            />
            <FooterLink
              href="https://www.deere.com/en/connect-with-john-deere/visit-john-deere/historic-site/"
              aria-label="Connect with John Deere - John Deere Historic Site"
              text="John Deere Historic Site"
            />
            <FooterLink
              href="https://www.deere.com/en/connect-with-john-deere/visit-john-deere/pavilion/"
              aria-label="Connect with John Deere - John Deere Pavilion"
              text="John Deere Pavilion"
            />
            <FooterLink
              href="https://www.deere.com/en/connect-with-john-deere/visit-john-deere/tractor-and-engine-museum/"
              aria-label="Connect with John Deere - John Deere Tractor & Engine Museum"
              text="John Deere Tractor & Engine Museum"
            />
            <FooterLink
              href="https://www.deere.com/en/connect-with-john-deere/visit-john-deere/world-headquarters/"
              aria-label="Connect with John Deere - World Headquarters"
              text="World Headquarters"
            />
            <FooterLink
              href="https://www.deere.com/en/connect-with-john-deere/john-deere-for-kids/"
              aria-label="Connect with John Deere - For the Kids"
              text="For the Kids"
            />
          </FooterList>
        </Box>
      </FooterNav>
      <FooterNav
        aria-label="footer country selector"
        style={{ borderTop: "1px solid gray" }}
      >
        <FooterList>
          <Box
            bgcolor={"background.default"}
            display={"flex"} // Use flex for alignment
            justifyContent={"center"} // Center the contents
            mt={1} // Margin-top
            p={3} // Padding
            borderRadius={2} // Rounded corners
            boxShadow={2}
          >
            <div style={{ marginLeft: "8px" }}>
              {" "}
              {/* Add some space between the title and the selector */}
              <CountrySelector
                countryName="United States"
                flagUrl="https://www.deere.com/assets/images/common/country-selector/usa-flag.png"
                countryLink="https://www.deere.com/en/global-country-selector/"
              />
            </div>
          </Box>
        </FooterList>
      </FooterNav>
      <FooterNav aria-label="footer utility navigation">
        <FooterList>
          <FooterLink
            href="https://www.deere.com/en/equipment/"
            text="Site Map"
          />
          <FooterLink
            href="https://www.deere.com/en/privacy-and-data/"
            text="Privacy and Data"
          />
          <FooterLink
            href="https://www.deere.com/en/privacy-and-data/cookie-statement/"
            text="Cookie Statement"
          />
          <FooterLink
            href="https://www.deere.com/en/privacy-and-data/terms/"
            text="Terms of Use"
          />
          <FooterLink
            href="https://www.deere.com/en/privacy-and-data/accessibility/"
            text="Accessibility"
          />
          <FooterLink
            href="https://www.deere.com/en/our-company/contact-us/"
            text="Contact Us"
          />
        </FooterList>
      </FooterNav>
      <FooterNav aria-label="footer social media links">
        <FooterList>
          <FooterLink
            href="http://www.facebook.com/JohnDeereUSCA"
            text={<Facebook />}
          />
          <FooterLink href="https://twitter.com/JohnDeere" text={<X />} />
          <FooterLink
            href="https://www.youtube.com/user/JohnDeere"
            text={<YouTube />}
          />
          <FooterLink
            href="https://www.linkedin.com/company/john-deere"
            text={<LinkedIn />}
          />
          <FooterLink
            href="http://instagram.com/johndeere"
            text={<Instagram />}
          />
          <FooterLink
            href="https://www.deere.com/en/forms/preference-center/"
            text={<Email />}
          />
        </FooterList>
      </FooterNav>
    </Footer>
  );
}
